import { Controller, useFormContext } from "react-hook-form";
import { DatePicker, DatePickerProps } from "./date-picker";

export type ControlledDatePickerProps = Omit<
  DatePickerProps,
  "onChange" | "value"
> & {
  name: string;
};

export function ControlledDatePicker({
  name,
  ...props
}: ControlledDatePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <DatePicker
            {...props}
            {...field}
            {...fieldState}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        );
      }}
    />
  );
}
